import React from "react";
import NACell from "../reusable/DataTable/NACell";
import { AccessControl } from "@careinfo/permission-required";
import TableActionButton from "../reusable/TableActionButton";
import DataTable from "../reusable/DataTable";
import APIS from "../../constant/Endpoint";
import { useNavigate } from "react-router-dom";
import usePermission from "../../customHooks/usePermission";

const BrokerList = () => {
  const navigate = useNavigate();
  const canUpdateSetting = usePermission({
    allowedPermissions: ["can_update_setting"],
  });
  const handleRowClick = (row: any) => {
    if (canUpdateSetting.isAllowed === false) return;
    navigate(`edit/${row?.original?.id}`);
  };
  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
  ];
  return (
    <DataTable
      url={APIS.BROKER}
      queryKey={"broker"}
      columns={defaultColumns}
      addNewPagePath={"create"}
      tableName={"broker"}
      onRowClick={handleRowClick}
    />
  );
};

export default BrokerList;
